import React, { useState } from 'react';
import TestimonialTemplate from './TestimonialTemplate';
import { testimonialReviews } from '../../../Constants/Data';

const TestimonialCarousel = () => {
    const [currentIndex, setCurrentIndex] = useState(0);

    const nextSlide = () => {
        setCurrentIndex((prev) => (prev + 1) % testimonialReviews.length);
    };

    const prevSlide = () => {
        setCurrentIndex((prev) => (prev - 1 + testimonialReviews.length) % testimonialReviews.length);
    };

    return (
        <div className="w-full flex flex-col py-10 3xl:py-16 bg-[#f0f0f0] relative">
            <div className="w-full relative px-4 sm:px-8 lg:px-12">
                <button
                    onClick={prevSlide}
                    className="absolute left-2 sm:left-4 lg:left-6 top-1/2 transform -translate-y-1/2 z-10 p-3 transition-all"
                >
                    <svg width="22" height="22" viewBox="0 0 12 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0.883618 8.59285C0.883618 8.36756 0.987368 8.14232 1.20966 7.9645L10.1018 0.85064C10.5316 0.506818 11.243 0.506818 11.6728 0.85064C12.1026 1.19446 12.1026 1.76358 11.6728 2.10742L3.56609 8.59277L11.6728 15.0781C12.1026 15.422 12.1026 15.9911 11.6728 16.3349C11.243 16.6787 10.5316 16.6787 10.1018 16.3349L1.20966 9.22105C0.987373 9.04322 0.883618 8.81792 0.883618 8.59269V8.59285Z" fill="#9a016a" />
                    </svg>
                </button>

                <div className="overflow-hidden">
                    <div
                        className="flex transition-transform duration-500 ease-in-out"
                        style={{
                            transform: `translateX(-${currentIndex * 100}%)`
                        }}
                    >
                        {testimonialReviews.map((review, index) => (
                            <div key={index} className="flex-shrink-0 w-full">
                                <TestimonialTemplate
                                    testimonial={review.testimonial}
                                    headshot={review.headshot}
                                    name={review.name}
                                    title={review.title}
                                />
                            </div>
                        ))}
                    </div>
                </div>

                <button
                    onClick={nextSlide}
                    className="absolute right-2 sm:right-4 lg:right-6 top-1/2 transform -translate-y-1/2 z-10 p-3 transition-all"
                >
                    <svg width="22" height="22" viewBox="0 0 12 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M11.9953 8.59269C11.9953 8.81799 11.8915 9.04322 11.6693 9.22105L2.77709 16.3349C2.34732 16.6787 1.63592 16.6787 1.20612 16.3349C0.776345 15.9911 0.776345 15.422 1.20612 15.0781L9.31282 8.59277L1.20612 2.10742C0.776345 1.7636 0.776345 1.19448 1.20612 0.85064C1.6359 0.506818 2.3473 0.506818 2.77709 0.85064L11.6693 7.9645C11.8915 8.14233 11.9953 8.36762 11.9953 8.59285V8.59269Z" fill="#9a016a" />
                    </svg>
                </button>
            </div>
        </div>
    );
};

export default TestimonialCarousel;